import { getTermValue } from '@/packages/JsonQuery';
import { EWCType } from '@/packages/api-models/common/json_query';

import { type ITagGroupConfig } from '../types';

const TEXT_MAP: { [key in EWCType]: string | null } = {
  [EWCType.Any]: null,
  [EWCType.Separated]: 'Раздельный санузел',
  [EWCType.United]: 'Совмещенный санузел',
};

export const wcType: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermValue('wc_type')(jsonQuery);
    if (!value) {
      return null;
    }

    const text = TEXT_MAP[value];
    if (!text) {
      return null;
    }

    return [
      {
        group: 'wcType',
        text,
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setUrbanBathroomType',
      arguments: [null],
    });
  },
};
